/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface AnalyticsSummaryEntity
 */
export interface AnalyticsSummaryEntity {
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    dailyContacts?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    weeklyContacts?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    monthlyContacts?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    dailySuggestions?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    weeklySuggestions?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    monthlySuggestions?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    dailyExtractions?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    weeklyExtractions?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    monthlyExtractions?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    dailyCustomers?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    weeklyCustomers?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    monthlyCustomers?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    dailyCustomerEntries?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    weeklyCustomerEntries?: number;
    /**
     * 
     * @type {number}
     * @memberof AnalyticsSummaryEntity
     */
    monthlyCustomerEntries?: number;
}

/**
 * Check if a given object implements the AnalyticsSummaryEntity interface.
 */
export function instanceOfAnalyticsSummaryEntity(value: object): boolean {
    return true;
}

export function AnalyticsSummaryEntityFromJSON(json: any): AnalyticsSummaryEntity {
    return AnalyticsSummaryEntityFromJSONTyped(json, false);
}

export function AnalyticsSummaryEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalyticsSummaryEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'dailyContacts': json['dailyContacts'] == null ? undefined : json['dailyContacts'],
        'weeklyContacts': json['weeklyContacts'] == null ? undefined : json['weeklyContacts'],
        'monthlyContacts': json['monthlyContacts'] == null ? undefined : json['monthlyContacts'],
        'dailySuggestions': json['dailySuggestions'] == null ? undefined : json['dailySuggestions'],
        'weeklySuggestions': json['weeklySuggestions'] == null ? undefined : json['weeklySuggestions'],
        'monthlySuggestions': json['monthlySuggestions'] == null ? undefined : json['monthlySuggestions'],
        'dailyExtractions': json['dailyExtractions'] == null ? undefined : json['dailyExtractions'],
        'weeklyExtractions': json['weeklyExtractions'] == null ? undefined : json['weeklyExtractions'],
        'monthlyExtractions': json['monthlyExtractions'] == null ? undefined : json['monthlyExtractions'],
        'dailyCustomers': json['dailyCustomers'] == null ? undefined : json['dailyCustomers'],
        'weeklyCustomers': json['weeklyCustomers'] == null ? undefined : json['weeklyCustomers'],
        'monthlyCustomers': json['monthlyCustomers'] == null ? undefined : json['monthlyCustomers'],
        'dailyCustomerEntries': json['dailyCustomerEntries'] == null ? undefined : json['dailyCustomerEntries'],
        'weeklyCustomerEntries': json['weeklyCustomerEntries'] == null ? undefined : json['weeklyCustomerEntries'],
        'monthlyCustomerEntries': json['monthlyCustomerEntries'] == null ? undefined : json['monthlyCustomerEntries'],
    };
}

export function AnalyticsSummaryEntityToJSON(value?: AnalyticsSummaryEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dailyContacts': value['dailyContacts'],
        'weeklyContacts': value['weeklyContacts'],
        'monthlyContacts': value['monthlyContacts'],
        'dailySuggestions': value['dailySuggestions'],
        'weeklySuggestions': value['weeklySuggestions'],
        'monthlySuggestions': value['monthlySuggestions'],
        'dailyExtractions': value['dailyExtractions'],
        'weeklyExtractions': value['weeklyExtractions'],
        'monthlyExtractions': value['monthlyExtractions'],
        'dailyCustomers': value['dailyCustomers'],
        'weeklyCustomers': value['weeklyCustomers'],
        'monthlyCustomers': value['monthlyCustomers'],
        'dailyCustomerEntries': value['dailyCustomerEntries'],
        'weeklyCustomerEntries': value['weeklyCustomerEntries'],
        'monthlyCustomerEntries': value['monthlyCustomerEntries'],
    };
}

